<template>
  <div>
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="图标" name="first">
        <h3 id="tu-biao-ji-he">图标集合</h3>
        <ul class="icon-list">
          <li>
            <span>
              <i class="el-icon-plus"></i>
              <span class="icon-name">el-icon-plus</span>
              <span class="icon-text">新增</span></span
            >
          </li>
          <li>
            <span>
              <i class="el-icon-edit"></i>
              <span class="icon-name">el-icon-edit</span>
              <span class="icon-text">修改</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-view"></i>
              <span class="icon-name">el-icon-view</span>
              <span class="icon-text">查看</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-delete"></i>
              <span class="icon-name">el-icon-delete</span>
              <span class="icon-text">删除</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-circle-check"></i>
              <span class="icon-name">el-icon-circle-check</span>
              <span class="icon-text">审核</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-circle-close"></i>
              <span class="icon-name">el-icon-circle-close</span>
              <span class="icon-text">取消审核</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-check"></i>
              <span class="icon-name">el-icon-check</span>
              <span class="icon-text">启用</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-close"></i>
              <span class="icon-name">el-icon-close</span>
              <span class="icon-text">禁用</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-document-delete"></i>
              <span class="icon-name">el-icon-document-delete</span>
              <span class="icon-text">冻结</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-document-checked"></i>
              <span class="icon-name">el-icon-document-checked</span>
              <span class="icon-text">解冻</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-download"></i>
              <span class="icon-name">el-icon-download</span>
              <span class="icon-text">导入</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-upload2"></i>
              <span class="icon-name">el-icon-upload2</span>
              <span class="icon-text">导出</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-refresh-left"></i>
              <span class="icon-name">el-icon-refresh-left</span>
              <span class="icon-text">驳回</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-circle-plus-outline"></i>
              <span class="icon-name">el-icon-circle-plus-outline</span>
              <span class="icon-text">追加</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-remove-outline"></i>
              <span class="icon-name">el-icon-remove-outline</span>
              <span class="icon-text">扣减</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-s-tools"></i>
              <span class="icon-name">el-icon-s-tools</span>
              <span class="icon-text">设置</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-user"></i>
              <span class="icon-name">el-icon-user</span>
              <span class="icon-text">我的</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-more-outline"></i>
              <span class="icon-name">el-icon-more-outline</span>
              <span class="icon-text">更多</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-sort"></i>
              <span class="icon-name">el-icon-sort</span>
              <span class="icon-text">排序</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-refresh"></i>
              <span class="icon-name">el-icon-refresh</span>
              <span class="icon-text">刷新</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-arrow-left"></i>
              <span class="icon-name">el-icon-arrow-left</span>
              <span class="icon-text">返回</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-arrow-right"></i>
              <span class="icon-name">el-icon-arrow-right</span>
              <span class="icon-text">前进</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-document"></i>
              <span class="icon-name">el-icon-document</span>
              <span class="icon-text">日志</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-folder"></i>
              <span class="icon-name">el-icon-folder</span>
              <span class="icon-text">文件</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-pie-chart"></i>
              <span class="icon-name">el-icon-pie-chart</span>
              <span class="icon-text">图表</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-location-outline"></i>
              <span class="icon-name">el-icon-location-outline</span>
              <span class="icon-text">位置</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-copy-document"></i>
              <span class="icon-name">el-icon-copy-document</span>
              <span class="icon-text">复制</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-link"></i>
              <span class="icon-name">el-icon-link</span>
              <span class="icon-text">链接</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-time"></i>
              <span class="icon-name">el-icon-time</span>
              <span class="icon-text">时间</span>
            </span>
          </li>
          <li>
            <span>
              <i class="el-icon-chat-dot-square"></i>
              <span class="icon-name">el-icon-chat-dot-square</span>
              <span class="icon-text">消息</span>
            </span>
          </li>
        </ul>
      </el-tab-pane>
      <el-tab-pane label="按钮" style="height: 90vh" name="second">
        <h3>
          常用按钮 (1.非危险类按钮和新增按钮底色不做具体要求。
          2.除红色外可间隔使用，需要遵守规范中对颜色的要求
          尽量不要同时存在过多颜色 )
        </h3>
        <el-row>
          <el-col span="3">
            <el-button type="primary" size="small" icon="el-icon-plus"
              >新增</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button plain size="small" icon="el-icon-edit">修改</el-button>
          </el-col>
          <el-col span="3">
            <el-button plain size="small" icon="el-icon-view">查看</el-button>
          </el-col>
          <el-col span="3">
            <el-button plain size="small" icon="el-icon-upload2"
              >导入</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button
              plain
              size="small"
              icon="el-icon-circle-check"
              @click="toExamine"
              >审核</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button plain size="small" icon="el-icon-download"
              >导出</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button plain size="small" icon="el-icon-check">启用</el-button>
          </el-col>
          <el-col span="3">
            <el-button plain size="small" icon="el-icon-circle-plus-outline"
              >追加</el-button
            >
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col span="3">
            <el-button plain size="small" icon="el-icon-remove-outline"
              >扣减</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button plain size="small" icon="el-icon-document-checked"
              >解冻</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="handleDelete"
              >删除</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button
              size="small"
              icon="el-icon-document-delete"
              @click="theFrozen"
              >冻结</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-document-delete"
              @click="theFrozen"
              >作废</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button
              size="small"
              icon="el-icon-refresh-left"
              @click="toRejected"
              >驳回</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button size="small" icon="el-icon-check" @click="toForbidden"
              >禁用</el-button
            >
          </el-col>
          <el-col span="3">
            <el-button
              size="small"
              icon="el-icon-circle-close"
              @click="toUnapprove"
              >取消审核</el-button
            >
          </el-col>
        </el-row>
        <el-collapse v-model="activeNa" accordion>
          <el-collapse-item title="显示代码" name="1">
            <prism-editor
              class="my-editor height-300"
              :key="ButtonClip"
              v-model="ButtonClip"
              :highlight="highlighter"
              readonly
              line-numbers
            ></prism-editor>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { Desc, DescMethod } from "./util/demodesc"; //日志及描述说明文件
DescMethod.initialize();
export default {
  components: {
    PrismEditor: DescMethod.PrismEditor,
  },
  data() {
    return {
      activeName: "first",
      activeNa: "",
      ButtonClip: Desc.ButtonClip,
    };
  },
  methods: {
    highlighter(code) {
      return DescMethod.highlight(code, DescMethod.languages.js);
    },
    handleDelete() {
      this.$confirm_danger("删除").then(() => {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      });
    },
    theFrozen() {
      this.$confirm_primary("冻结").then(() => {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      });
    },
    toExamine() {
      this.$confirm_primary("审核").then(() => {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      });
    },
    toUnapprove() {
      this.$confirm_primary("取消审核").then(() => {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      });
    },
    toForbidden() {
      this.$confirm_primary("禁用").then(() => {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      });
    },
    toRejected() {
      this.$confirm_primary("驳回").then(() => {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-collapse-item__header {
  font-weight: 800 !important;
  font-size: 16px !important;
}

.page-component .content > h3 {
  margin: 55px 0 20px;
}
.page-container h2,
.page-container h3,
.page-container h4,
.page-container h5 {
  font-weight: 400;
  color: #1f2f3d;
}
.icon-text {
  display: block !important;
  padding: 15px 0 0 0;
}

.icon-list li:hover i {
  color: #5cb6ff;
  transition: color 0.15s linear;
}

.icon-list li:hover span {
  color: #5cb6ff;
  transition: color 0.15s linear;
}

.page-component .content > ul:not(.timeline) {
  margin: 10px 0;
  padding: 0 0 0 20px;
  font-size: 14px;
  color: #5e6d82;
  line-height: 2em;
}

.page-component .content > ul.icon-list {
  overflow: hidden;
  list-style: none;
  padding: 0 !important;
  border: 1px solid #eaeefb;
  border-radius: 4px;
}

.icon-list li {
  float: left;
  width: 16.66%;
  text-align: center;
  height: 145px;
  line-height: 120px;
  color: #666;
  font-size: 13px;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin-right: -1px;
  margin-bottom: -1px;
}

.icon-list li:after,
.icon-list li span {
  display: inline-block;
  vertical-align: middle;
}

.icon-list li i {
  display: block;
  font-size: 32px;
  margin-bottom: 15px;
  margin-top: 19px;
  color: #606266;
  transition: color 0.15s linear;
}

[class*=" el-icon-"],
[class^="el-icon-"] {
  font-family: element-icons !important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-list li .icon-name {
  display: inline-block;
  padding: 0 3px;
  height: 1em;
  margin-bottom: 15px;
}

ul {
  list-style: none;
}

.page-component .content > ul.icon-list {
  overflow: hidden;
  list-style: none;
  padding: 0 !important;
  border: 1px solid #eaeefb;
  border-radius: 4px;
}

.icon-list li:after,
.icon-list li span {
  display: inline-block;
  vertical-align: middle;
}

.icon-list li .icon-name {
  display: inline-block;
  padding: 0 3px;
  height: 1em;
}

.icon-list li span {
  line-height: normal;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  color: #99a9bf;
  transition: color 0.15s linear;
  font-size: 14px !important;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 98%;
  height: 500px;
}
</style>
